// Iter 904 (Kamel) — 📱 fiche voyage sur smartphone : barre fixe en bas (retour catalogue · prix · S'inscrire · WhatsApp)
// visible seulement une fois le bouton « S'inscrire » du haut de page sorti de l'écran.
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import ShareButton from './ShareButton';

export default function TripMobileBar({ trip, anchorId = 'top-inscription-cta' }) {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const el = document.querySelector(`[data-testid="${anchorId}"]`);
    if (!el || !('IntersectionObserver' in window)) { setVisible(true); return; }
    const io = new IntersectionObserver(([e]) => setVisible(!e.isIntersecting && e.boundingClientRect.top < 0), { threshold: 0 });
    io.observe(el);
    return () => io.disconnect();
  }, [anchorId]);
  if (!trip || !visible) return null;
  return (
    <div className="lg:hidden fixed bottom-0 inset-x-0 z-[60] bg-white/95 backdrop-blur border-t border-gray-200 shadow-[0_-4px_16px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} data-testid="trip-mobile-bar">
      <div className="flex items-center gap-2 px-3 h-16">
        <Link to="/voyages" onClick={() => window.scrollTo(0, 0)} className="flex flex-col items-center justify-center w-12 h-12 rounded-xl text-gray-600" aria-label="Retour aux voyages" data-testid="trip-mobile-bar-back">
          <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth={2} viewBox="0 0 24 24" aria-hidden><path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" /></svg>
          <span className="text-[10px] font-bold">Voyages</span>
        </Link>
        <Link to="/inscription" onClick={() => window.scrollTo(0, 0)}
          className="flex-1 h-12 rounded-full bg-[#C60B1E] text-white font-black flex items-center justify-center gap-2 shadow-lg" data-testid="trip-mobile-bar-inscription">
          <span className="text-sm">✍️ S'inscrire</span>
          <span className="text-xs font-bold bg-white/20 rounded-full px-2 py-0.5" data-testid="trip-mobile-bar-price">{trip.weekly_pricing ? 'dès ' : ''}{trip.price_from} €</span>
        </Link>
        <ShareButton trip={trip} variant="bar" />
      </div>
    </div>
  );
}
